import React from 'react';
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const SERIES = [
  { key: 'teams', label: 'Club Teams', color: '#0D3B7A' },
  { key: 'players', label: 'Players', color: '#1B5E20' },
  { key: 'coaches', label: 'Coaches', color: '#0277BD' },
  { key: 'regionalTeams', label: 'Regional Teams', color: '#D84315' },
];

const RegistrationTrendChart = ({ data = [] }) => {
  const hasData = data.some((row) => SERIES.some(({ key }) => row[key] > 0));

  if (!hasData) {
    return (
      <div className="h-72 flex items-center justify-center text-sm text-muted-foreground">
        No registration activity in the last 6 months
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={288}>
      <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
        <XAxis dataKey="month" tick={{ fontSize: 12 }} stroke="var(--color-muted-foreground)" />
        <YAxis allowDecimals={false} tick={{ fontSize: 12 }} stroke="var(--color-muted-foreground)" />
        <Tooltip
          contentStyle={{
            backgroundColor: 'var(--color-card)',
            border: '1px solid var(--color-border)',
            borderRadius: '8px',
          }}
        />
        <Legend />
        {SERIES.map(({ key, label, color }) => (
          <Area
            key={key}
            type="monotone"
            dataKey={key}
            name={label}
            stroke={color}
            fill={color}
            fillOpacity={0.15}
            strokeWidth={2}
          />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default RegistrationTrendChart;
